import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';

// Styles
import './action-list.scss';

// Components
import Button, { BUTTON_STYLES } from '../button/button';
import GenericModal, { MODAL_TYPE } from '../generic-modal/generic-modal';
import AddStudents from '../add-students/add-students';

// Context
import ConsoleModalContext from '../../containers/console/context/console-modal-context';

// Helpers
import Resources from '../../helpers/resources';
import PortalCommunication from '../../helpers/portal-communications';
import { getParam } from '../../helpers/utils';
import useIsOneRosterActivatedSchool from '../../hooks/use-is-one-roster-activated-school';

function ActionList({ forwardRef, studentsLength, currentClassName, currentClassId, closeActionList, exportStudents, isSisSchool }) {
    const { showConsoleModal, setShowConsoleModal, setConsoleModalContent } = useContext(ConsoleModalContext);
    // Configuration item for the certificate module, which is being configured in the config manager
    const [certificateModuleId, setCertificateModuleId] = useState(null);
    const isOneRosterActivatedSchool = useIsOneRosterActivatedSchool();

    // ComponentDidMount
    useEffect(() => {
        // retrieve the value for girl ids for the info modal
        const retrieveConfigItem = async () => {
            const configValue = await Resources.getConfigurationItem('CertificateModuleId');
            setCertificateModuleId(configValue);
        };

        retrieveConfigItem();
    }, []);

    // Add Students Modal
    const closeAddModal = () => {
        setShowConsoleModal(false);
    };
    const titleTrans = () => (
        isOneRosterActivatedSchool ?
            <Trans id={'Move/Copy Modal - Title'} /> :
            <Trans id={'Move/Copy Modal - Title - {currentClassName}'}>
                placeholderMessage {currentClassName}
            </Trans>
    );
    const showAddModal = () => {
        setShowConsoleModal(!showConsoleModal);
        setConsoleModalContent((
            <GenericModal
                title={(titleTrans())}
                closeHandler={closeAddModal}
                parentClasses="add-students"
                isOneRosterActivatedSchool={isOneRosterActivatedSchool}
                type={MODAL_TYPE.floating}>
                <AddStudents
                    currentClassId={currentClassId}
                />
            </GenericModal>
        ));
        closeActionList();
    };

    const certificatesCallback = () => {
        if (certificateModuleId !== null) {
            const productId = getParam('productId');
            const productKey = `product-${productId}`;
            PortalCommunication.requestModuleChange(certificateModuleId[productKey], {
                productId
            });
        }
    };

    const moveCopyStudentsOption = () => {
        if (isSisSchool) return null;

        return (
            <li className="action-list__item">
                <Button
                    importedClasses="action-list__button"
                    buttonStyle={BUTTON_STYLES.iconText}
                    iconName="movecopy"
                    callback={showAddModal}
                    visibleText={<Trans id={'Action List - Move/Copy Students'} />} />
            </li>
        );
    };

    return (
        <ul ref={forwardRef} className="action-list">
            <li className="action-list__item">
                <Button
                    importedClasses="action-list__button action-list__button--excel"
                    buttonStyle={BUTTON_STYLES.iconText}
                    iconName="excel"
                    isBtnDisabled={studentsLength === 0}
                    visibleText={<Trans id={'Action List - Excel'} />}
                    callback={exportStudents} />
            </li>
            {moveCopyStudentsOption()}
            <li className="action-list__item">
                <Button
                    importedClasses="action-list__button"
                    buttonStyle={BUTTON_STYLES.iconText}
                    iconName="certificates"
                    visibleText={<Trans id={'Action List - Certificates'} />}
                    callback={certificatesCallback}
                />
            </li>
        </ul>
    );
}

ActionList.propTypes = {
    forwardRef: PropTypes.any,
    studentsLength: PropTypes.number,
    currentClassName: PropTypes.string,
    currentClassId: PropTypes.number,
    closeActionList: PropTypes.func,
    exportStudents: PropTypes.func,
    isSisSchool: PropTypes.bool
};

export default React.forwardRef((props, ref) => (<ActionList forwardRef={ref} {...props} />));



// WEBPACK FOOTER //
// ./components/tools/action-list.js